import { isAuthorized } from '../auth';
/**
 * Returns the availability of the route based on the user's roles
 * and the deployed services and feature flags.
 *
 * @param route the route to check
 * @param filterProps the state info needed for filtering
 * @returns {RouteAvailability}
 */
export const getRouteAvailability = (route, filterProps) => {
    const { projectId, authGroups, serviceIds, featureFlags } = filterProps;
    const hasRequiredRole = isAuthorized(route.requiredAuth, authGroups, projectId);
    const isAuthenticated = !!authGroups?.length;
    const hasRequiredService = !route.requiredService ||
        serviceIds?.includes(route.requiredService.serviceId);
    const hasTeaser = !!route.requiredService?.teaserComponent;
    const hasFeatureFlag = route.featureFlag === undefined || featureFlags.includes(route.featureFlag);
    return hasRequiredRole && hasRequiredService && hasFeatureFlag
        ? 'available'
        : !hasRequiredRole && !isAuthenticated
            ? 'needs-auth'
            : !hasRequiredService && hasTeaser
                ? 'teaser'
                : 'hidden';
};
/**
 * Only returns true for routes that fit the following criteria:
 *
 * The required feature flags are present
 * AND the user has a required role
 * AND
 * * the required service is present
 * * OR there is a teaser component
 * * OR it is a top-level remote route
 */
export const canRouteBeUsed = (route, props) => getRouteAvailability(route, props) !== 'hidden';
/**
 * If the given route can be used, recursively filter its subroutes.
 *
 * @param route the route whose subroutes need filtering
 * @param props the state info needed for filtering
 * @returns a modified copy of the route with its subroutes filtered
 */
export const filterSubRoutes = (route, props) => ({
    ...route,
    routes: route.routes
        ?.filter((route) => canRouteBeUsed(route, props))
        .map((route) => filterSubRoutes(route, props)),
});
